var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recommend_activity_config_pane" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：", prop: "activityName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.form.activityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityName", $$v)
                  },
                  expression: "form.activityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "点餐类型：", prop: "scenes" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.scenes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "scenes", $$v)
                    },
                    expression: "form.scenes",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: "1" } }, [
                    _vm._v("堂食"),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _vm._v("自提"),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _vm._v("外卖"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "时间类型：", prop: "timeType" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleTimeTypeChange },
                  model: {
                    value: _vm.form.timeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "timeType", $$v)
                    },
                    expression: "form.timeType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("长期生效")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("时间段生效"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v("周期性生效"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.timeType === 2
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "执行日期：" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.timeType === 2 || _vm.form.timeType === 3
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "执行时间：" } },
                  [
                    _c("el-time-picker", {
                      attrs: {
                        "is-range": "",
                        format: "HH:mm",
                        "value-format": "HH:mm",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        placeholder: "选择时间范围",
                      },
                      model: {
                        value: _vm.timeRange,
                        callback: function ($$v) {
                          _vm.timeRange = $$v
                        },
                        expression: "timeRange",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.timeType === 3
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "生效星期：" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.checkedWeekdays,
                          callback: function ($$v) {
                            _vm.checkedWeekdays = $$v
                          },
                          expression: "checkedWeekdays",
                        },
                      },
                      [
                        _c("el-checkbox", { attrs: { label: 1 } }, [
                          _vm._v("周一"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 2 } }, [
                          _vm._v("周二"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 3 } }, [
                          _vm._v("周三"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 4 } }, [
                          _vm._v("周四"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 5 } }, [
                          _vm._v("周五"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 6 } }, [
                          _vm._v("周六"),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 7 } }, [
                          _vm._v("周日"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "推荐商品：", prop: "checkedGoodsList" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#909399",
                    "font-size": "12px",
                    "margin-bottom": "8px",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(" 最多可配置3个商品，按排序值从小到大显示\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "70%" },
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    placeholder: "请搜索选项推荐商品",
                    "remote-method": _vm.searchGoods,
                    loading: _vm.searchGoodsLoading,
                    "value-key": "goodsId",
                    disabled: _vm.form.checkedGoodsList.length >= 3,
                  },
                  model: {
                    value: _vm.checkedGoods,
                    callback: function ($$v) {
                      _vm.checkedGoods = $$v
                    },
                    expression: "checkedGoods",
                  },
                },
                _vm._l(_vm.goodsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.goodsId,
                      attrs: { label: item.goodsName, value: item },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.goodsName))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    disabled: _vm.form.checkedGoodsList.length >= 3,
                  },
                  on: { click: _vm.addGoods },
                },
                [_vm._v("\n          添加\n        ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: _vm.goodsTableKey,
                  staticStyle: { width: "70%" },
                  attrs: { border: "", data: _vm.form.checkedGoodsList },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsCode", label: "商品编号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "排序", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                min: 0,
                                max: 9999,
                                size: "small",
                                "controls-position": "right",
                              },
                              model: {
                                value: scope.row.sorts,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sorts", $$v)
                                },
                                expression: "scope.row.sorts",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeGoods(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                移除\n              ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否启用：", prop: "status" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 1, "false-label": 0 },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                [_vm._v("\n          启用\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  on: { change: _vm.handleStoreScopeChange },
                  model: {
                    value: _vm.form.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeScope", $$v)
                    },
                    expression: "form.storeScope",
                  },
                },
                [_vm._v("\n          全部门店\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c("region-store-pane", {
                    key: regionStore.regionId,
                    ref: "regionStore_" + regionStore.regionId,
                    refInFor: true,
                    attrs: {
                      "region-store": regionStore,
                      "echo-store-ids": _vm.form.relatedStoreIdList,
                    },
                    on: { change: _vm.handleStoreChange },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("\n          提交\n        ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }